import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import { OfferOverflowList } from 'embed/constants'
import { DepositsOffer } from 'embed/constants/models'

import DepositsFilter from 'embed/components/DepositsFilter/container'
import DepositsOfferList from 'embed/components/DepositsOfferList/container'
import ThemeConsumer from 'embed/components/ThemeConsumer'
import { DepositAmountModal } from '../DepositAmountModal'

const styles = require('embed/styles/shared')

interface Props {
  depositsOffers: DepositsOffer[]
  dispatchSeeAllDepositsSelected: () => void
  dispatchSeeMoreDepositsSelected: () => void
  offerOverflow: OfferOverflowList
  offerStyleIsCompact: boolean
  onDepositAmountSelected: () => void
  seeMoreOffersAvailable: boolean
  seeAllOffersAvailable: boolean
  shouldShowDepositAmountModal: boolean
  productSubTypeFilter: unknown
}

export const OfferListView: React.FC<Props> = (props) => {
  let showAdditionalOffers
  if (props.seeAllOffersAvailable === true) {
    showAdditionalOffers = (
      <ThemeConsumer>
        {({ colorPrimary, colorTextPrimary }) => (
          <span
            className={classnames(
              styles.seeMore,
              css`
                a {
                  color: ${colorPrimary};
                  &:hover {
                    color: ${colorTextPrimary};
                  }
                }
              `,
            )}
          >
            <a onClick={props.dispatchSeeAllDepositsSelected}>See All Offers</a>
          </span>
        )}
      </ThemeConsumer>
    )
  } else if (props.seeMoreOffersAvailable && props.depositsOffers.length > 0) {
    // Temporarily removing See More Offers link as per:
    // https://app.asana.com/0/665379957680278/907678026651235
    // Future TODO: Add this back or permanently remove.
    showAdditionalOffers = null
    // showAdditionalOffers = (<ThemeConsumer>
    //   {({ colorPrimary, colorTextPrimary }) => (
    //     <span className={classnames(styles.seeMore, css`
    //       a {
    //         color: ${colorPrimary};
    //         &:hover {color: ${colorTextPrimary};}
    //       }`)}>
    //       <a onClick={props.dispatchSeeMoreDepositsSelected}>See More Offers</a>
    //     </span>
    //   )}
    // </ThemeConsumer>)
  }

  return (
    <div>
      {props.shouldShowDepositAmountModal && <DepositAmountModal onSelected={props.onDepositAmountSelected} />}
      <DepositsFilter />
      <DepositsOfferList depositsOffers={props.depositsOffers} offerStyleIsCompact={props.offerStyleIsCompact} />
      {showAdditionalOffers}
    </div>
  )
}
